import { render, staticRenderFns } from "./MyView.vue?vue&type=template&id=c13d9f52&scoped=true"
import script from "./MyView.vue?vue&type=script&lang=js"
export * from "./MyView.vue?vue&type=script&lang=js"
import style0 from "./MyView.vue?vue&type=style&index=0&id=c13d9f52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13d9f52",
  null
  
)

export default component.exports